module.exports = __webpack_public_path__ + "assets/images/hotel-03.3fd0a66f8ffc093837103d4fac39c850.svg";